import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import MessageAPI from '../../../../axios/message';
import { PanelIcon } from '../../user-panel';
import { PanelPagination } from '../panel-ui';
import { UserMessage } from '../user-message/user-message';

export const UserMessageList = ({ type }) => {
    const { t } = useTranslation(["message"]);
    const [messages, setMessages] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [pageNum, setPageNum] = useState(1);

    useEffect(() => {
        let cancelled = false;
        const request = type === "sent_messages" ? MessageAPI.getSentMessages : MessageAPI.getReceivedMessages;
        request(pageNum).then(response => {
            if (cancelled) return;
            setMessages(response.data.results);
            setPageCount(response.data.page_count);
            setLoaded(true);
        }).catch(err => console.log(err));
        return () => { cancelled = true; };
    }, [pageNum, type]);

    if (!loaded) return null;

    if (messages.length === 0) {
        return (
            <div className='hs-panel-card hs-panel-empty'>
                <span className='hs-panel-empty-icon'><PanelIcon name='msg' size={24} /></span>
                <h2>{t("no_messages")}</h2>
                {type === "received_messages" && <p>{t("no_messages_text")}</p>}
            </div>
        );
    }

    return (
        <>
            <div className='hs-panel-card hs-panel-messages'>
                {messages.map(message => (
                    <UserMessage data={message} type={type} key={`user-message-${message.id}`}
                        onRemoved={() => setMessages(messages.filter(m => m.id !== message.id))} />
                ))}
            </div>
            <PanelPagination page={pageNum} pageCount={pageCount} onChange={setPageNum} />
        </>
    );
};
